window.onload = function() {
  if (!customElements.get('testimonials-slide')) {
    customElements.define('testimonials-slide', class TestimonialsComponent extends HTMLElement {
      constructor() {
    super();
    this.testimDots = Array.prototype.slice.call(this.querySelector("#testim-dots").children);
    this.testimContent = Array.prototype.slice.call(this.querySelector("#testim-content").children);
    this.testimLeftArrow = this.querySelector("#left-arrow");
    this.testimRightArrow = this.querySelector("#right-arrow");
    this.testimSpeed = 5000;
    this.autoplay = this.dataset.autoplay === "true";
    this.currentSlide = 0;
    this.currentActive = 0;
    this.testimTimer = null;

        

    this.playSlide = (slide) => {
      for (let k = 0; k < this.testimDots.length; k++) {
        this.testimContent[k].classList.remove("active");
        this.testimContent[k].classList.remove("inactive");
        this.testimDots[k].classList.remove("active");
      }
    
      if (slide < 0) {
        slide = this.testimContent.length - 1;
        this.currentSlide = slide;
      } else if (slide >= this.testimContent.length) {
        slide = 0;
        this.currentSlide = slide;
      } else {
        this.currentSlide = slide;
      }
    
      if (this.currentActive !== this.currentSlide && this.testimContent[this.currentActive]) {
        this.testimContent[this.currentActive].classList.add("inactive");
      }
      if (this.testimContent[this.currentSlide]) {
        this.testimContent[this.currentSlide].classList.add("active");
      }
      if (this.testimDots[this.currentSlide]) {
        this.testimDots[this.currentSlide].classList.add("active");
      }
    
      this.currentActive = this.currentSlide;
    
      clearTimeout(this.testimTimer);
      if(this.autoplay){
        this.testimTimer = setTimeout(() => {
          this.playSlide(this.currentSlide + 1);
        }, this.testimSpeed);
      }
      
    };

    this.testimLeftArrow.addEventListener("click", () => {
      this.playSlide(this.currentSlide - 1);
    });

    this.testimRightArrow.addEventListener("click", () => {
      this.playSlide(this.currentSlide + 1);
    });

    for (let l = 0; l < this.testimDots.length; l++) {
      this.testimDots[l].addEventListener("click", () => {
        this.playSlide(l);
      });
    }

    this.playSlide(this.currentSlide);
  }
    });
  }
};



/*   let	testim = document.getElementById("testim"),
		testimDots = Array.prototype.slice.call(document.getElementById("testim-dots").children),
        testimContent = Array.prototype.slice.call(document.getElementById("testim-content").children),
        testimLeftArrow = document.getElementById("left-arrow"),
        testimRightArrow = document.getElementById("right-arrow"),
        testimSpeed = 5000,
        currentSlide = 0,
        currentActive = 0,
        testimTimer,
		touchStartPos,
		touchEndPos,
		touchPosDiff,
		ignoreTouch = 30;

window.onload = function() {

    // Testim Script
    function playSlide(slide) {
        for (let k = 0; k < testimDots.length; k++) {
            testimContent[k].classList.remove("active");
            testimContent[k].classList.remove("inactive");
            testimDots[k].classList.remove("active");
        }

        if (slide < 0) {
            slide = currentSlide = testimContent.length - 1;
        }

        if (slide > testimContent.length - 1) {
            slide = currentSlide = 0;
        }

        if (currentActive != currentSlide) {
            testimContent[currentActive].classList.add("inactive");            
        }
        testimContent[slide].classList.add("active");
        testimDots[slide].classList.add("active");

        currentActive = currentSlide;
    
        clearTimeout(testimTimer);
        testimTimer = setTimeout(function() {
            playSlide(currentSlide += 1);
        }, testimSpeed)
    }

    testimLeftArrow.addEventListener("click", function() {
        playSlide(currentSlide -= 1);
    })

    testimRightArrow.addEventListener("click", function() {
        playSlide(currentSlide += 1);
    })    

    for (let l = 0; l < testimDots.length; l++) {
        testimDots[l].addEventListener("click", function() {
            playSlide(currentSlide = testimDots.indexOf(this));
        })
    }

    playSlide(currentSlide);
}*/